import InlineTranslation from './component'
export default InlineTranslation
